import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Anime from "./Anime";

import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Anime />
  </BrowserRouter>
);
